// hook into the uploads store and pack a resumable js instance into it
import { useUploadsStore } from '@/Stores/uploads'
const uploads = useUploadsStore()

// we'll create a resumable instance and hook it straight into the store, using
// the `on` method to listen to events, we'll bind the files to vues reactivity
import Resumable from 'resumablejs'
const r = new Resumable({
    target: '/upload',
    maxChunkRetries: 1,
    testChunks: false,
})

if( ! r.support ) {
    // Resumable.js isn't supported, fall back on a different method
    throw 'Uploads are not supported on this browser! Please use a modern browser like Chrome or Firefox.';
}

// mutate the state in line with r
r.on('fileAdded', (file, event) => { // file is a ResumableFile object - event is a native event
    uploads.addFile({
        ...file,
        progress: 0,
        name: file.file.name,
        type: file.file.type,
    })
})
r.on('fileProgress', (file, event) => {
    uploads.updateFile({
        ...file,
        progress: file.progress(),
        name: file.file.name,
        type: file.file.type,
    })
})

// inject ourselves into the stores state using pinias built in $patch method
uploads.$patch({ r })
